import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

import Dropdown from '../Atoms/Dropdown';

const propTypes = exact({
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  max: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  showBeyondMaxOption: PropTypes.bool,
});

const defaultProps = {
  labelText: 'How many?',
  max: undefined,
  showBeyondMaxOption: false,
  options: undefined,
};

function UpgradeDropdown(props) {
  let options = props.options || [];
  if (options.length === 0 && props.max) {
    options = [...Array(props.max)].map((_, index) => ({
      text: index + 1,
      value: index + 1,
    }));
  }

  if (props.showBeyondMaxOption) {
    options.push({ text: `${props.max} +`, value: props.max + 1 });
  }

  return (
    <div className="UpgradeDropdown">
      <label className="UpgradeDropdown_label" htmlFor="partySelect">
        {props.labelText}
      </label>
      <Dropdown
        blockName="UpgradeDropdown_dropdown"
        fieldValue={props.selectedValue}
        handleChange={props.handleChange}
        modifier="bold"
        options={options}
      />
    </div>
  );
}

UpgradeDropdown.propTypes = propTypes;
UpgradeDropdown.defaultProps = defaultProps;

export default UpgradeDropdown;
